"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactEmotion = require("react-emotion");

var _themes = _interopRequireDefault(require("../themes"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  cursor: pointer;\n\n  & .", " {\n    visibility: hidden;\n    opacity: 0;\n  }\n\n  &:hover .", " {\n    visibility: visible;\n    opacity: 1;\n    transform: translate(-50%, -12px);\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  width: 250px;\n  color: ", ";\n  background-color: ", ";\n  font-size: 12px;\n  font-family: ", ";\n  font-weight: 300;\n  padding: 8px 10px;\n  margin: 0;\n  box-sizing: border-box;\n  border-radius: 4px;\n  line-height: 1.5;\n  letter-spacing: 0.3px;\n  left: 50%;\n  bottom: 100%;\n  transform: translate(-50%, -30px);\n  transition: opacity 200ms ease 0s, transform 200ms ease 0s;\n\n  &:after {\n    position: absolute;\n    content: \"\";\n    top: 100%;\n    left: 50%;\n    margin-left: -7px;\n    border-width: 7px;\n    border-style: solid;\n    border-color: ", " transparent transparent transparent;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var tooltipTextStyles = (0, _reactEmotion.css)(_templateObject(), _themes.default.colors.white, _themes.default.colors.darkestGrey, _themes.default.typography.fontFamily.default, _themes.default.colors.darkestGrey);
var tooltipContainerStyles = (0, _reactEmotion.css)(_templateObject2(), tooltipTextStyles, tooltipTextStyles);

var Tooltip = function Tooltip(_ref) {
  var children = _ref.children,
      content = _ref.content;
  return _react.default.createElement("div", {
    className: tooltipContainerStyles
  }, _react.default.createElement("p", {
    className: tooltipTextStyles
  }, content), _react.default.createElement("div", null, children));
};

Tooltip.propTypes = {
  /** Element that will trigger the Tooltip when hovered */
  children: _propTypes.default.node.isRequired,

  /** Content of the Tooltip */
  content: _propTypes.default.string.isRequired
};
var _default = Tooltip;
exports.default = _default;